import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { OrganisationInterface } from '@careapp/angular-sdk';

import { FormCoreComponent } from '../form-core';

@Component({
  selector: 'organisation-form',
  templateUrl: './organisation-form.component.html',
  styleUrls: ['./organisation-form.component.scss']
})
export class OrganisationFormComponent extends FormCoreComponent<OrganisationInterface> {
  @Input()
  set organisation(value: OrganisationInterface) {
    if (value) {
      let result = { ...value };
      result.address = result.address || {};
      this.form.patchValue(result || {}, { emitEvent: false, onlySelf: true });
    }
  }

  constructor() {
    super();
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      enabled: new FormControl(true),
      contactNumber: new FormControl('', Validators.required),
      address: new FormGroup({
        address1: new FormControl('', Validators.required),
        address2: new FormControl(),
        town: new FormControl('', Validators.required),
        state: new FormControl('', Validators.required),
        postcode: new FormControl('', Validators.required),
        country: new FormControl('', Validators.required)
      })
    });
  }
}
